import styled from "styled-components";

import { Tab } from "@libraries/mui/components";

import { windowWidth } from "@styles/global";

const Container = styled(Tab)`
  color: black !important;
  text-transform: none !important;
  padding: 0 10px !important;
  min-height: 60px !important;
  min-width: 200px !important;
  max-width: 200px !important;

  :hover {
    background-color: #F5F5F5;
  }

  .MuiSvgIcon-root {    
    @media ( min-width: ${windowWidth.tablet} ) {
      width: 0.7em;
      height: 0.7em;
    }

    :hover {
      background-color: rgb(200, 200, 200);
      border-radius: 50%;
    }
  }

  @media ( max-width: ${windowWidth.laptop.large} ) {
    min-height: 50px !important;
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    min-width: 100% !important;
    max-width: 100% !important;
  }

`;

const Name = styled.div`
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  flex-grow: 1;
  overflow: hidden;

  * {
    align-self: flex-start !important;
  }

  > :first-child {
    font-weight: bold;
    font-size: 15px;
    text-align: start;

    @media ( max-width: ${windowWidth.laptop.large} ) {
      font-size: 13.5px;
    }
  }

  > :last-child {
    font-size: 13.5px;
    text-align: start;
    color: #666666;
    font-weight: normal;

    @media ( max-width: ${windowWidth.laptop.large} ) {
      font-size: 12px;
    }

    @media ( max-width: ${windowWidth.mobile.large} ) {
      font-size: 10px;
    }
  }
`;

export { Container, Name };
